/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_No_Pace_DataInputs */

const en_ui_color_by_reason_no_pace_data = /** @type {(inputs: Ui_Color_By_Reason_No_Pace_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pace data`)
};

const de_ui_color_by_reason_no_pace_data = /** @type {(inputs: Ui_Color_By_Reason_No_Pace_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Pace-Daten`)
};

/**
* | output |
* | --- |
* | "No pace data" |
*
* @param {Ui_Color_By_Reason_No_Pace_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_no_pace_data = /** @type {((inputs?: Ui_Color_By_Reason_No_Pace_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_No_Pace_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_no_pace_data(inputs)
	return de_ui_color_by_reason_no_pace_data(inputs)
});